import { render, staticRenderFns } from "./contractorManagement1.vue?vue&type=template&id=56f1bf78&scoped=true&"
import script from "./contractorManagement1.vue?vue&type=script&lang=js&"
export * from "./contractorManagement1.vue?vue&type=script&lang=js&"
import style0 from "./contractorManagement1.vue?vue&type=style&index=0&id=56f1bf78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f1bf78",
  null
  
)

export default component.exports